import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  DASHBOARD: {
    id: 'Dashboard.dashboard',
    defaultMessage: 'Dashboard',
    description: '[Type: Label][Vis.: low] - Dashboards section of nav bar',
  },
});

const Dashboard = () => (
  <MainNavButton
    href="/dashboard/"
    label={t(COPY.DASHBOARD)}
    navItem="dashboard"
  />
);

export default Dashboard;
export { Dashboard };
